const devopsServicesData = [
  {
    title: "CI/CD",
    description:
      "Design pipelines, ephemeral environments, and reliable releases with automated gates.",
    bullets: ["Build/Test", "Preview", "Deploy", "Release Train"],
    minHeight: 400,
  },
  {
    title: "Infra as Code",
    description:
      "Provision idempotent infrastructure with Terraform/Pulumi modules and policy enforcement.",
    bullets: ["Terraform", "Pulumi", "Modules", "Policies"],
    minHeight: 400,
  },
  {
    title: "Containers & Orchestration",
    description:
      "Build and operate Docker/K8s platforms with autoscaling, ingress, and resilience patterns.",
    bullets: ["Docker", "Kubernetes", "Autoscaling", "Ingress"],
    minHeight: 400,
  },
  {
    title: "Observability",
    description:
      "End‑to‑end observability with metrics, logs, traces, SLOs, and actionable alerts.",
    bullets: ["Prometheus", "Grafana", "Tracing", "SLO/SLI"],
    minHeight: 400,
  },
  {
    title: "Security",
    description:
      "Shift‑left security with SAST/DAST, secret scanning, signing, and RBAC policies.",
    bullets: ["SAST/DAST", "Secrets", "Signing", "RBAC"],
    minHeight: 400,
  },
  {
    title: "Ops",
    description:
      "Operational excellence with on‑call rotations, incident response, runbooks, and postmortems.",
    bullets: ["On‑call", "Incidents", "Runbooks", "Reports"],
    minHeight: 400,
  },
  {
    title: "Platform Engineering",
    description:
      "Create golden paths and IDPs with self‑service portals, templates, and guardrails.",
    bullets: ["IDP", "Golden Paths", "Backstage", "Templates"],
    minHeight: 400,
  },
  {
    title: "Cost & Capacity",
    description:
      "Right‑size infra with autoscaling, FinOps, limits, and budgets to control spend and scale.",
    bullets: ["Autoscale", "FinOps", "Limits", "Budgets"],
    minHeight: 400,
  },
  {
    title: "Release Management",
    description:
      "Release safely with Blue/Green, Canary, feature flags, and automated rollback strategies.",
    bullets: ["Blue/Green", "Canary", "Feature Flags", "Rollback"],
    minHeight: 400,
  },
];

export default devopsServicesData;
